// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3PzIz","amount":"Amount_amount__fwDSB","tip":"Amount_tip__2nubT","tipHeader":"Amount_tipHeader__3n2jl","tipsWrap":"Amount_tipsWrap__169-0"};